/**
 * @file 是否需要render
 * @author hanzhichen(hanzhichen@baijiahulian.com)
 * @date 2020-12-04
 */

// 当cas已登录, 子系统未登录, 子系统查询cas接口时会直接进行登录, 跳转到首页, 此时不想进行cas的渲染, 所以加了一个标记
export default {
    state: {
        shouldRender: false,
    },

    action: {
        updateShouldRender(value) {
            return {shouldRender: value};
        }
    },

    reducer: {
        updateShouldRender(state, action, error) {
            if (!error) {
                const {shouldRender} = action.payload;

                return {
                    shouldRender
                };
            }
            return {...state};
        }
    }
};
